module.exports = __webpack_public_path__ + "static/specialist_body_bg-4d9dee401c9fba636719d1ddaad6bc5c.png";